
import { useState } from 'react';

const galleryImages = [
  {
    url: 'https://public.readdy.ai/ai/img_res/c863c2840fa28b0a49ffed996e2d75a8.jpg',
    title: 'أجواء المطعم الراقية'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Elegant%20breakfast%20buffet%20spread%20in%20luxury%20hotel%2C%20variety%20of%20gourmet%20dishes%20beautifully%20arranged%2C%20professional%20food%20display%20with%20white%20tablecloths%2C%20warm%20lighting%20highlighting%20fresh%20ingredients%2C%20clean%20simple%20background&width=800&height=600&seq=gallery2&orientation=landscape',
    title: 'بوفيه الفطور الفاخر'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Premium%20breakfast%20dishes%20elegantly%20plated%2C%20gourmet%20hotel%20restaurant%20food%20presentation%2C%20fresh%20ingredients%20artistically%20arranged%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20appetizing%20presentation&width=800&height=600&seq=gallery3&orientation=landscape',
    title: 'أطباق مميزة'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20hotel%20restaurant%20seating%20area%2C%20comfortable%20elegant%20dining%20chairs%20and%20tables%2C%20sophisticated%20interior%20design%20with%20warm%20ambient%20lighting%2C%20clean%20white%20and%20neutral%20tones%2C%20professional%20hospitality%20photography&width=800&height=600&seq=gallery4&orientation=landscape',
    title: 'مساحات الجلوس'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Fresh%20bakery%20and%20pastry%20selection%20on%20elegant%20display%2C%20croissants%20breads%20and%20gourmet%20baked%20goods%2C%20luxury%20hotel%20breakfast%20buffet%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background&width=800&height=600&seq=gallery5&orientation=landscape',
    title: 'المخبوزات الطازجة'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Elegant%20hotel%20restaurant%20table%20setting%20with%20fine%20dining%20setup%2C%20sophisticated%20place%20settings%20with%20white%20linens%2C%20modern%20luxury%20hospitality%20design%2C%20clean%20minimalist%20aesthetic%20with%20warm%20lighting%2C%20professional%20photography&width=800&height=600&seq=gallery6&orientation=landscape',
    title: 'تفاصيل الخدمة'
  }
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            معرض الصور
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            اكتشف أجواء مطعمنا الفاخرة وتشكيلة أطباقنا المميزة
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative w-full h-80 overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(index)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 w-full">
                  <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
                    {image.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 left-6 text-white text-4xl hover:text-teal-400 transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <div className="max-w-6xl w-full h-full flex items-center justify-center">
            <img
              src={galleryImages[selectedImage].url}
              alt={galleryImages[selectedImage].title}
              className="max-w-full max-h-full object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
}
